// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1koLq","icon":"styles_icon__1FE-C"};